import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-caidan_zidongyingxiao",
  "use": "icon-icon-caidan_zidongyingxiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-caidan_zidongyingxiao\"><path d=\"M766.08 864H257.92a32 32 0 1 0 0 64h508.16a32 32 0 1 0 0-64zM384 640a32 32 0 0 1-28.48-20.16l-47.36-114.88-61.44 61.76a32 32 0 0 1-45.44-45.44l96-96a32 32 0 0 1 52.48 10.88l37.44 93.76 96-192A32 32 0 0 1 512 320a32 32 0 0 1 28.8 15.68l72.64 121.28 131.2-157.44a32 32 0 0 1 49.28 40.96l-160 192a32 32 0 0 1-52.16-4.16l-65.92-109.76-102.08 203.84A32 32 0 0 1 384 640z\" fill=\"#333333\" p-id=\"6325\" /><path d=\"M832 800H192a96 96 0 0 1-96-96V192a96 96 0 0 1 96-96h640a96 96 0 0 1 96 96h-64a32 32 0 0 0-32-32H192a32 32 0 0 0-32 32v512a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32v-298.56h64V704a96 96 0 0 1-96 96z\" fill=\"#333333\" p-id=\"6326\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-caidan_zidongyingxiao.svg
// module id = VpfV
// module chunks = 95